export const PUBLISH_REQUEST_ITEMS_PER_PAGE = "10";

export const CONFIG_CI_TEST_TASKS_ITEMS_PER_PAGE = "10";

export const configCiTestCaseStatuses = {
    new: "NEW",
    done: "DONE",
    inProgress: "IN_PROGRESS",
    skipped: "SKIPPED",
    canceled: "CANCELED",
    failed: "FAILED",
    success: "SUCCESS"
};
